export default __webpack_public_path__ + "static/media/still_19.763b3d92.jpg";